import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col py-1 space-y-2" };
const __default__ = {
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'DropdownMenu',
    props: {
        ident: { type: Boolean },
        open: { type: Boolean },
        placement: null
    },
    emits: ['update:open'],
    setup(__props, { emit }) {
        const props = __props;
        const popoverInnerClass = computed(() => {
            const base = 'bg-white border rounded-md dark:border-black dark:bg-gray-850 shadow-tile';
            const identation = 'ml-6 -mt-2';
            return props.ident ? `${base} ${identation}` : base;
        });
        function handleOpen(value) {
            emit('update:open', value);
        }
        return (_ctx, _cache) => {
            const _component_v_popover = _resolveComponent("v-popover");
            return (_openBlock(), _createBlock(_component_v_popover, {
                placement: __props.placement || 'bottom-start',
                "popover-class": "unique-dropdown-menu-vkrt45",
                "popover-arrow-class": "hidden",
                "popover-inner-class": _unref(popoverInnerClass),
                trigger: "manual",
                open: __props.open,
                class: "flex flex-col",
                "onUpdate:open": handleOpen
            }, {
                popover: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "menu-items")
                    ])
                ]),
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "item")
                ], undefined, true),
                _: 3
            }, 8, ["placement", "popover-inner-class", "open"]));
        };
    }
});
